import { connect } from 'react-redux';
import { IState } from '../../store';

import { IOfferValueAddedServicesProps, OfferValueAddedServices } from './index';
import { isMlSearchEnabled } from '../../selectors/isMlSearchEnabled';

export const mapStateToProps = (state: IState): IOfferValueAddedServicesProps => {
  return {
    valueAddedServices: state.offerData.offer.valueAddedServices,
    isMlSearchEnabled: isMlSearchEnabled(state),
  };
};

export const OfferValueAddedServicesContainer = connect<IOfferValueAddedServicesProps>(mapStateToProps)(
  OfferValueAddedServices,
);
